import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PdfService} from '../../_services/api/pdf.service';
import {FileLikeObject, FileUploader} from 'ng2-file-upload';
import {concat} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Document} from '../../models/browseDocuments.model';
import {FileService} from '../../_services/api/file.service';
import {cast_to_array, cast_to_extension, cast_to_formats, cast_to_icons} from '../../allowedTypes';
import {animate, animateChild, query, stagger, style, transition, trigger} from '@angular/animations';
import {ProcessingStatus} from '../../models/processingStatus.model';
import {AuthService} from '../../_services/auth/auth.service';
import {DeviceDetectorService, DeviceInfo} from 'ngx-device-detector';
import {DicomParserHelper} from '../../_services/dicom/dicom-parser.helper';
import {filetypeinfo} from 'magic-bytes.js';
import {UploadErrorDialogComponent} from '../shared/upload-error-dialog/upload-error-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {saveAs} from 'file-saver';


interface SupportedFiles {
  img: string;
  title: string;
  extension: string;
}

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
  animations: [
    trigger( 'supportedFilesList', [
      transition( ':enter', [
        query( '@sfItem',
          stagger(30, animateChild()))
      ])
    ]),
    trigger('sfItem', [
      transition( ':enter', [
        style({opacity: 0, transform: 'translateY(50%)'}),
        animate('500ms 0.1s cubic-bezier(0.35, 0, 0.25, 1)')
      ])
    ]),
    trigger( 'dropDownZone', [
      transition( ':enter', [
        style({opacity: 0, transform: 'scale(0)'}),
        animate('500ms 0.1s cubic-bezier(0.35, 0, 0.25, 1)')
      ])
    ])
  ]
})
export class UploadFileComponent implements OnInit {

  browserType: DeviceInfo;
  allowedMimeType: any;
  allowedExtensions: string;
  form: FormGroup;
  progress: number[];
  uploadLoading = true;

  uploadingFileStatus: any;
  uploadingStart = false;
  supportedFiles: SupportedFiles[];

  dicomFormDataObject: any = {};
  dicomFolderList: any = {};
  dicomSeries: any = [];
  queueNumber = 0;

  processingStatus: ProcessingStatus;
  documentsDuringAnonimization: Document[] = [];
  dicomDirectoryUploaderVisible = false;
  notDicomsFile: any = {};

  public uploader: FileUploader = new FileUploader({});
  public hasBaseDropZoneOver = false;

  constructor(private formBuilder: FormBuilder, private pdfService: PdfService, private snackBar: MatSnackBar,
              private fileService: FileService, private auth: AuthService, private deviceService: DeviceDetectorService,
              private dicomParser: DicomParserHelper, private cdr: ChangeDetectorRef, private dialog: MatDialog) {
    this.browserType = this.deviceService.getDeviceInfo();
    this.uploadingFileStatus = {};
  }

  ngOnInit(): void {
    this.supportedFiles = [];
    this.auth.checkUserStatus().subscribe( res => {
      this.uploadLoading = false;
      const availableFormats = cast_to_formats(res.allowed_data_types);
      this.supportedFiles = cast_to_icons(res.allowed_data_types);
      this.allowedMimeType = cast_to_array(availableFormats);

      this.allowedExtensions = cast_to_extension(availableFormats);
      this.dicomDirectoryUploaderVisible = this.checkIfShowUploadDicom();
      this.uploader = new FileUploader({allowedMimeType: this.allowedMimeType});
      this.uploader.onWhenAddingFileFailed = (item) => {
        this.snackBar.open('Supported file formats are ' + this.allowedExtensions, 'close', {
          duration: 2000,
        });
      };
    },
      error => {
      console.log(error);
    });

    this.form = this.formBuilder.group({
      document: [''],
      name: ['']
    });
    this.progress = [0];
    this.processingStatus = {
      running: false, title: 'Warning',
      message: 'Some of your files are still being uploaded. Do you want to leave the page and stop the anonymization process?',
      confirm: 'Leave', dismiss: 'Stay'
    };
  }

  wait(ms) {
    const start = new Date().getTime();
    let end = start;
    while (end < start + ms) {
      end = new Date().getTime();
    }
  }

  processDicomFolder(queueNumber, queueId, filtered, allFiles){
    const startId = queueNumber > 0 ? this.dicomSeries.slice(0, -1).reduce((accumulator, current) => {
      return accumulator + current;
    }, 0) : 0;

    for (let i = 0; i < filtered.length; i++) {
      if (i > 0 && i % 500 === 0) {
        this.wait(500);
        this.uploadingFileStatus = {...this.uploadingFileStatus};
      }
      const file = filtered[i];

      const filereader = new FileReader();

      filereader.onloadend = (f) => {
        this.uploadingFileStatus = {...this.uploadingFileStatus};
        if (f.target.result instanceof ArrayBuffer) {
          const bytes = new Uint8Array(f.target.result);
          const fti = filetypeinfo(bytes);
          if (fti.some(item => item.typename === 'dcm') ||
            (file.name.substr(file.name.length - 4) === '.nii' && fti.length === 0) ||
            (file.name.substr(file.name.length - 4) === '.stl' && (fti.length === 0 || fti.some(item => item.typename === 'pdb'))) ||
            (file.name.substr(file.name.length - 4) === '.obj' && fti.length === 0) ||
            (fti.some(item => item.typename === 'tar.gz') && file.name.substr(file.name.length - 7) === '.nii.gz'))  {
            this.uploadDicomAfterAnonymization(file, queueId, i + 1 + startId, allFiles, 'directory');
          } else {
            this.uploadingFileStatus[queueId].anonymizing += 1 / filtered.length;
            this.uploadingFileStatus = {...this.uploadingFileStatus};
            this.notDicomsFile[queueId].push(file.webkitRelativePath);
            this.uploadDicomFormData(queueId, allFiles, 'directory');
          }
        }
      };

      filereader.readAsArrayBuffer(file);
    }

  }

  uploadDicoms(files, event) {
    this.uploader.queue = [];
    this.processingStatus.running = true;

    const queueId = new Date().getTime().toString();
    if (this.dicomFormDataObject[queueId] === undefined) {
      this.dicomFormDataObject[queueId] = new FormData();
      this.dicomFolderList[queueId] = [];
    }
    const allFiles = files.length;
    const filtered = [...files].filter(file => (file.type === '' || file.type === 'application/dicom' || file.type === 'model/obj') && (file.name[0] !== '.'));
    this.notDicomsFile[queueId] = [...files].filter(file => (file.type !== '' && file.type !== 'application/dicom'  && file.type !== 'model/obj') || (file.name[0] === '.')).map(x => x.webkitRelativePath);
    this.dicomSeries.push(allFiles);

    console.log(filtered);

    if (filtered.length > 0 ) {
      this.uploadingStart = true;
      this.uploadingFileStatus[queueId] = {uploading: 0, processing: 0.01, anonymizing: 0, compressing: 0, type: 'dicom-folder'};
      this.uploadingFileStatus = {...this.uploadingFileStatus};

      setTimeout(() => {
        this.processDicomFolder(this.queueNumber, queueId, filtered, allFiles);
        this.queueNumber += 1;
      });
    }

    // this.uploadingStatus.allFiles += requests.length;
    event.target.value = null;
  }

  checkIfAllDone(): boolean {
    let allDone = true;
    console.log(this.uploadingFileStatus);
    Object.keys(this.uploadingFileStatus).forEach(v => {
      if (this.uploadingFileStatus[v].processing !== 1 || this.uploadingFileStatus[v].uploading !== 1) {
        allDone = false;
      }
    });
    return allDone;
  }

  uploadRequests(requests, queueIds) {
    let i = 0;
    concat(...requests).subscribe(
      (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            this.uploadingFileStatus[queueIds[i]].uploading = event.loaded / event.total;
            break;
          case HttpEventType.Response:
            this.uploadingFileStatus[queueIds[i]].uploading = 1;
            if (event.body.status === 'success') {
              this.uploadingFileStatus[queueIds[i]].processing = 1;
              if (event.body.doc) {
                event.body.doc.forEach(file => {
                    this.documentsDuringAnonimization.push(new Document(file.name, file.size, file.extension, file.docId, file.uploadedAt,
                      file.docType, 'Ready', '', 100, {isSelected: false, selectionMode: false}, 'Ready'));
                });
              }
            } else if (event.body.status === 'error') {
              if (this.documentsDuringAnonimization.length === 0) {
                this.uploadingStart = false;
              }
              this.snackBar.open(event.body.message, 'close', {
                duration: 5000,
              });
            }
            i += 1;
            if (this.checkIfAllDone()) {
              this.uploadingFileStatus = {};
              this.processingStatus.running = false;
            }
        }
        this.uploadingFileStatus = {...this.uploadingFileStatus};
      }, error => {
        this.processingStatus.running = false;
        this.snackBar.open('File couldn\'t be uploaded.', 'close', {
          duration: 2000,
        });
        delete this.uploadingFileStatus[queueIds[i]];
        this.uploadingFileStatus = {... this.uploadingFileStatus};
        const newRequest = requests.slice(i + 1);

        if (newRequest.length > 0) {
          this.uploadRequests(newRequest, queueIds.slice(i + 1));
        }

        if (Object.keys(this.uploadingFileStatus).length === 0 ) {
          this.uploadingStart = false;
        }

      });
  }

  onChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form.get('document').setValue(file);
      this.form.get('name').setValue(file.name);
    }
    this.upload();
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public dropped(e: any): void {
    this.upload();
  }

  checkIfShowUploadDicom(): boolean {
    if (this.allowedMimeType.indexOf('application/dicom') > -1) {
      if (this.browserType.browser === 'Chrome' && parseInt(this.browserType.browser_version.split('.')[0]) > 6) {
        return true;
      } else if (this.browserType.browser === 'Firefox' && parseInt(this.browserType.browser_version.split('.')[0]) > 50) {
        return true;
      } else if (this.browserType.browser === 'Opera' && parseInt(this.browserType.browser_version.split('.')[0]) > 15) {
        return true;
      } else if (this.browserType.browser === 'Edge' && parseInt(this.browserType.browser_version.split('.')[0]) > 13) {
        return true;
      } else if (this.browserType.browser === 'Safari' && parseInt(this.browserType.browser_version.split('.')[0]) > 11) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      if (fileItem.file.size <= 160 && fileItem.file.type === '') {
        this.messageOnDirectoryDragAndDrop();
      } else if (this.allowedMimeType.indexOf(fileItem.file.type) > -1) {
        return fileItem.file;
      }
    }).filter( (item) => {
      return item !== undefined;
    });
  }

  appendFormData(file, queueId, formData) {
    formData.append('file' , file.rawFile, file.name);
    formData.append('name', file.name);
    formData.append('size', file.size);
    formData.append('queue_id', queueId);
    return formData;
  }

  uploadDicomAfterAnonymization(file, queueId, fileNumber, allFiles, type) {
    if (this.dicomFormDataObject[queueId] === undefined) {
      this.dicomFormDataObject[queueId] = new FormData();
      this.dicomFolderList[queueId] = [];
    }
    const uploadFile = type === 'directory' ? file : file.rawFile;

    uploadFile.arrayBuffer().then(buff => {
      this.dicomParser.anonymizeFileInWebWorkerAndReturnArrayBuffer(buff, fileNumber, file.name, queueId).subscribe(res => {
        const resQueueId: string = res[2];

        this.uploadingFileStatus[resQueueId].anonymizing += 1 / allFiles;
        this.uploadingFileStatus = {...this.uploadingFileStatus};
        const blob = new Blob([res[0]]);

        if (type === 'directory') {
          if (!this.dicomFormDataObject[resQueueId].has('name')) {
            const directoryName = file.webkitRelativePath.split('/')[0];
            this.dicomFormDataObject[resQueueId].append('name' , directoryName);
          }
          this.dicomFolderList[resQueueId].push(new File([blob], file.webkitRelativePath, {lastModified: new Date().getTime()}));
        } else {
          this.dicomFormDataObject[resQueueId].append('file' , blob, file.name);
          this.dicomFormDataObject[resQueueId].append('name', file.name);
          this.dicomFormDataObject[resQueueId].append('size', file.size);
          this.dicomFormDataObject[resQueueId].append('queue_id', resQueueId);
        }
        this.uploadDicomFormData(resQueueId, allFiles, type);
      });
    }, error => {
      console.log(error);
      if (type !== 'directory') {
        this.messageOnDirectoryDragAndDrop();
        this.uploadDicomFormData(queueId, allFiles - 1, type);
      }

    });
  }

  uploadDicomFormData(queueId, allFiles, type) {
    const readyFiles = type === 'directory' ? this.dicomFolderList[queueId].length + this.notDicomsFile[queueId].length : this.dicomFormDataObject[queueId].getAll('file').length;
    if (readyFiles === allFiles) {
      if (this.dicomFormDataObject[queueId].has('file') || this.dicomFolderList[queueId].length > 0) {
        if (type === 'directory') {
          this.uploadingFileStatus[queueId].anonymizing = 1;
          const name = this.dicomFormDataObject[queueId].get('name');
          const id = Object.keys(this.dicomFolderList).filter(x => x <= queueId).length * -1;
          this.dicomParser.createZip(this.dicomFolderList[queueId], name + '.zip', id, queueId).subscribe(res => {
            if (res[0] instanceof Blob) {
              const resQueueId: string = res[1];
              this.dicomFormDataObject[resQueueId].append('file_anonymised' , res[0], name + '.zip');
              this.dicomFormDataObject[resQueueId].append('name', name );
              this.dicomFormDataObject[resQueueId].append('size', res[0].size);
              this.dicomFormDataObject[resQueueId].append('queue_id', resQueueId);

              if (this.notDicomsFile[resQueueId].length > 0) {
                const createShareFileDialog = this.dialog.open(UploadErrorDialogComponent, {
                  data: {
                    fileList: this.notDicomsFile[resQueueId],
                    allFiles: this.dicomFolderList[resQueueId].length + this.notDicomsFile[resQueueId].length
                  },
                  width: '90%',
                  maxWidth: '635px',
                });
              }

              this.uploadRequests([this.fileService.uploadZipDirectory(this.dicomFormDataObject[resQueueId])], [resQueueId]);
            } else if (res.status === 'update') {
              this.uploadingFileStatus[res.queueId].compressing = res.progress;
              this.uploadingFileStatus = {...this.uploadingFileStatus};
            }
          }, error => {});
        } else {
          this.uploadRequests([this.fileService.upload(this.dicomFormDataObject[queueId])], [queueId]);
        }
      } else {
        delete this.uploadingFileStatus[queueId];
        this.uploadingFileStatus = {...this.uploadingFileStatus};
        this.uploadingStart = Object.keys(this.uploadingFileStatus).length > 0;
        this.processingStatus.running = this.uploadingStart;
      }
    }
  }

  messageOnDirectoryDragAndDrop() {
    this.snackBar.open('We have detected that you have tried to upload a folder. To proceed use \'DICOM folder\' button.', 'close', {
      duration: 2000,
    });
  }

  upload() {
    const files = this.getFiles();
    const requests = [];
    const DICOMFiles = [];
    const queueIds = [];

    this.uploader.queue = [];

    this.processingStatus.running = true;
    const dicomQueueId = new Date().getTime().toString();

    files.forEach((file) => {
      const queueId = Math.random().toString(36).slice(2, 7);
      if (file.type === '' || file.type === 'application/dicom') {
        if (this.uploadingFileStatus[dicomQueueId] === undefined) {
          this.uploadingFileStatus[dicomQueueId] = {uploading: 0, processing: 0.01, type: 'dicom'};
          this.notDicomsFile[dicomQueueId] = [];
        }
        DICOMFiles.push(file);
      } else {
        this.uploadingFileStatus[queueId] = {uploading: 0, processing: 0.01, type: 'media-file'};
        this.notDicomsFile[queueId] = [];
        requests.push(this.fileService.upload(this.appendFormData(file, queueId, new FormData())));
        queueIds.push(queueId);
      }
      this.uploadingStart = true;
    });

    DICOMFiles.forEach( (dicomFile: any, i) => {
      this.uploadDicomAfterAnonymization(dicomFile, dicomQueueId, i + 1, DICOMFiles.length, 'file');
    });

    this.uploadRequests(requests, queueIds);
  }


  deleteAnonymizeFile(doc: Document) {
    this.documentsDuringAnonimization = this.documentsDuringAnonimization.filter(obj => obj.docId !== doc.docId);
    if (this.documentsDuringAnonimization.length === 0) {
        this.uploadingStart = false;
    }
  }

  downloadAll(){
    Object.keys(this.dicomFormDataObject).forEach( item => {
      if (this.dicomFormDataObject[item].get('file_anonymised')){
        saveAs(this.dicomFormDataObject[item].get('file_anonymised'), this.dicomFormDataObject[item].get('name') + '.zip');
      }
    });
  }
}
